import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from "react";
const CareersContext = /*#__PURE__*/ createContext({});
export const CareersProvider = ({ children })=>{
    const [search, setSearch] = useState("");
    const [department, setDepartment] = useState(null);
    const [location, setLocation] = useState(null);
    return /*#__PURE__*/ _jsx(CareersContext.Provider, {
        value: {
            search,
            setSearch,
            department,
            setDepartment,
            location,
            setLocation
        },
        children: children
    });
};
export const useFilters = ()=>useContext(CareersContext);
